import { Component, OnInit, ViewChild } from "@angular/core";
import { TaskService } from "../../master-services/tasks/task.service";
import { RestService } from "../../master-services/Rest/rest.service";
import { FilexcelService } from "../../master-services/FileExcel/filexcel.service";
import { ITask, ITaskLine, ITaskAsesor, ITaskType, ITaskHistory, ITaskHistoryRequest, ITaskFinishRequest, ITaskFilters, ITaskCustomerBasicInfo, ITasksExportProspectsResponse, ITaskResponse, ITaskFile } from "../../master-models/task.model";
import { ICustomerContact } from "../../master-models/customer-contact.model";
import { Observable } from "rxjs";
import swal from "sweetalert2";
import { ModalBasicComponent } from "../../shared/modal-basic/modal-basic.component";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../master-services/User/user.service";

@Component({
  selector: "app-task-management",
  templateUrl: "./task-management.component.html",
  styleUrls: ["./task-management.component.scss",
    '../../../assets/icon/icofont/css/icofont.scss'],
})
export class TaskManagementComponent implements OnInit {
  tasks: ITask[] = [];
  loading = false;

  pageNumber = 0;
  perPage = 15;
  totalTasks = 0;

  taksLines: ITaskLine[] = [];
  lineIdToEdit: number = 0;
  newLine: string = '';

  taskTypes: ITaskType[] = [];
  typeIdToEdit: number = 0;
  newType: string = '';

  asesors: ITaskAsesor[] = [];
  customerOrigins: any[] = [];

  newTask: any = {
    task_lines_id: null,
    task_types_id: null,
    name: '',
    contact_name: '',
    email: '',
    telephone: '',
    origin_id: null,
    user_asigned_id: null,
    description: '',
    priority: null,
  };

  priorityOptions = [
    { label: 'Baja', value: 0 },
    { label: 'Media', value: 1 },
    { label: 'Alta', value: 2 },
  ];

  stateOptions = [
    { label: 'Pendiente', value: 0 },
    { label: 'En progreso', value: 1 },
    { label: 'Completada', value: 2 },
  ];

  newTaskMode: 'prospecto' | 'cliente' = 'prospecto';

taskEditionMode = false;

  MAX_ATTACHMENTS = 10;
  MAX_ATTACHMENT_SIZE_MB = 20;
  ALLOWED_ATTACHMENT_EXTENSIONS = [
    'pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt',
  ];
  selectedFiles: File[] = [];
  editingTaskId: number | null = null;

  taskFilters: ITaskFilters = {
    asesor_id: '',
    date_from: '',
    date_to: '',
    name: '',
    task_lines_id: '',
    task_types_id: '',
    origin_id: '',
    state: '',
    priority: '',
  };

  dateFromPicker: NgbDateStruct = null;
  dateToPicker: NgbDateStruct = null;

  isFiltering = false;

  taskIndicators: {
    total: number | '';
    pending: number | '';
    finished: number | '';
    avg_days_to_finish: number | '';
  } | null = null;

  profile: string | null = null;
  userId: number | null = null;
  crmAdmin: number | null = null;

  selectedTask: ITask | null = null;
  taskHistory: ITaskHistory[] = [];

  newHistoryEntry: ITaskHistoryRequest = {
    description: '',
    task_id: 0,
  };

  newFinishEntry: ITaskFinishRequest = {
    description: '',
  };

  finishAsCustomer = false;
  customersBasic: ITaskCustomerBasicInfo[] = [];
  selectedCustomerId: number | null = null;
  loadingCustomers = false;

  customerContacts: ICustomerContact[] = [];
  selectedContactId: number | null = null;
  loadingContacts = false;

  historyFormMode: 'history' | 'finish' = 'history';

  taskFiles: ITaskFile[] = [];
  loadingTaskFiles = false;

  @ViewChild('modalFormType') modalFormType: ModalBasicComponent;
  @ViewChild('modalFormLine') modalFormLine: ModalBasicComponent;
  @ViewChild('modalLinesList') modalLinesList: ModalBasicComponent;
  @ViewChild('modalTypesList') modalTypesList: ModalBasicComponent;
  @ViewChild('modalFormTask') modalFormTask: ModalBasicComponent;
  @ViewChild('modalTaskDetail') modalTaskDetail: ModalBasicComponent;
  @ViewChild('modalFormHistory') modalFormHistory: ModalBasicComponent;
  @ViewChild('modalTaskFiles') modalTaskFiles: ModalBasicComponent;

  constructor(
    private taskService: TaskService,
    private restService: RestService,
    private filexcelService: FilexcelService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.profile = localStorage.getItem("profile");
    this.userId = Number(localStorage.getItem("userid"));

    this.getUser(this.userId);
    this.getTaskAsesors();
    this.getTaskLines();
    this.getTaskTypes();
    this.getAllCustomerOrigins();
    this.loadCustomersBasicInfo();
  }

  get isAdmin(): boolean {
    return this.profile === '1';
  }

  get isCrmAdmin(): boolean {
    return this.crmAdmin === 1;
  }

  get selectedCustomerMissingOrigin(): boolean {
    if (this.newTaskMode !== 'cliente' || !this.selectedCustomerId) {
      return false;
    }
    const customer = this.customersBasic.find(c => c.id === this.selectedCustomerId);
    if (!customer) {
      return false;
    }
    const originId = customer.origin_id;
    return originId === null || originId === undefined || originId === 0;
  }

  get canSubmitNewTask(): boolean {
    if (this.newTaskMode === 'cliente' && this.selectedCustomerMissingOrigin) {
      return false;
    }
    return true;
  }

  getTasks() {
    this.loading = true;

    this.taskService.getTasksFilter(this.taskFilters, this.pageNumber + 1).subscribe(
      (res) => {
        this.tasks = res.data.data;
        this.totalTasks = res.data.total;
        this.perPage = res.data.per_page;
        this.taskIndicators = (res.indicators && Object.keys(res.indicators).length > 0)
          ? res.indicators
          : null;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        const message =
          error.error && error.error.error
            ? error.error.error
            : "Ocurrio un error durante la obtencion de las tareas.";
        swal({
          title: "Error",
          text: message,
          type: "error",
        });
      }
    );
  }

  ngbDateToString(date: NgbDateStruct): string {
    if (!date) {
      return '';
    }
    const year = date.year;
    const month = String(date.month).padStart(2, '0');
    const day = String(date.day).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  onDateFromChange(date: NgbDateStruct) {
    this.dateFromPicker = date;
    this.taskFilters.date_from = this.ngbDateToString(date);
  }

  onDateToChange(date: NgbDateStruct) {
    this.dateToPicker = date;
    this.taskFilters.date_to = this.ngbDateToString(date);
  }

  applyFilters() {
    this.pageNumber = 0;
    this.isFiltering = true;
    this.getTasks();
  }

  buildExportFileName(): string {
    const parts: string[] = [];

    if (this.taskFilters.date_from) {
      parts.push(this.taskFilters.date_from);
    }
    if (this.taskFilters.date_to) {
      parts.push(this.taskFilters.date_to);
    }

    if (this.taskFilters.asesor_id !== '' && this.taskFilters.asesor_id !== null) {
      const asesor = this.asesors.find(a => a.id === this.taskFilters.asesor_id);
      if (asesor && asesor.name) {
        parts.push(`Asesor-${this.sanitizeFileName(asesor.name)}`);
      }
    }

    if (this.taskFilters.task_lines_id !== '' && this.taskFilters.task_lines_id !== null) {
      const line = this.taksLines.find(l => l.id === this.taskFilters.task_lines_id);
      if (line && line.name) {
        parts.push(this.sanitizeFileName(line.name));
      }
    }

    if (this.taskFilters.task_types_id !== '' && this.taskFilters.task_types_id !== null) {
      const type = this.taskTypes.find(t => t.id === this.taskFilters.task_types_id);
      if (type && type.name) {
        parts.push(this.sanitizeFileName(type.name));
      }
    }

    if (this.taskFilters.origin_id !== '' && this.taskFilters.origin_id !== null) {
      const origin = this.customerOrigins.find(o => o.id === this.taskFilters.origin_id);
      if (origin && origin.origin) {
        parts.push(this.sanitizeFileName(origin.origin));
      }
    }

    if (this.taskFilters.state !== '' && this.taskFilters.state !== null) {
      const stateLabel = this.getStateLabel(this.taskFilters.state);
      parts.push(this.sanitizeFileName(stateLabel));
    }

    if (this.taskFilters.priority !== '' && this.taskFilters.priority !== null) {
      const priorityLabel = this.getPriorityLabel(this.taskFilters.priority);
      parts.push(this.sanitizeFileName(priorityLabel));
    }

    if (this.taskFilters.name) {
      parts.push(this.sanitizeFileName(this.taskFilters.name));
    }

    return parts.length > 0 ? `tareas_${parts.join('_')}` : 'tareas';
  }

  sanitizeFileName(text: string): string {
    if (!text) {
      return '';
    }
    return text
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9_\-]+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '');
  }

mapTaskToExportRow(t: ITask): any {
    const linea = (t.task_line && t.task_line.name) ? t.task_line.name : '';
    const tipo = (t.task_type && t.task_type.name) ? t.task_type.name : '';
    const origen = (t.origin && t.origin.origin) ? t.origin.origin : '';
    const asesor = (t.user_assigned && t.user_assigned.name) ? t.user_assigned.name : '';

    const row: any = {};
    row.Linea = linea;
    row.Tipo = tipo;
    row.Nombre = t.name || '';
    row.Email = t.email || '';
    row.Telefono = t.telephone || '';
    row.Origen = origen;
    row.Asesor = asesor;
    row.Prioridad = this.getPriorityLabel(t.priority);
    row.Estado = this.getStateLabel(t.state);
    row['Nombre de contacto'] = t.contact_name || '';
    row['Fecha de creación'] = t.created_at || '';
    row['Fecha de finalización'] = (t.finished_at && t.finished_at.trim()) ? t.finished_at : '';
    row.Descripcion = t.description || '';
    return row;
  }

  exportTasks() {
    if (!this.taskFilters.date_from || !this.taskFilters.date_to) {
      swal({
        title: 'Rango de fechas obligatorio',
        text: 'Para exportar a Excel debe ingresar el rango de fechas (Creado desde y Creado hasta).',
        type: 'error',
      });
      return;
    }

    const from = new Date(this.taskFilters.date_from);
    const to = new Date(this.taskFilters.date_to);

    if (isNaN(from.getTime()) || isNaN(to.getTime())) {
      swal({
        title: 'Fechas inválidas',
        text: 'El formato de las fechas no es válido.',
        type: 'error',
      });
      return;
    }

    const diffMs = to.getTime() - from.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    if (diffDays < 0) {
      swal({
        title: 'Rango de fechas inválido',
        text: 'La fecha "Creado hasta" debe ser posterior o igual a la fecha "Creado desde".',
        type: 'error',
      });
      return;
    }

    const maxDays = 92;
    if (diffDays > maxDays) {
      swal({
        title: 'Rango de fechas demasiado amplio',
        text: 'El rango seleccionado no puede exceder los 3 meses (90 días). Por favor reduzca el rango.',
        type: 'error',
      });
      return;
    }

    swal({
      title: 'Generando Excel ...',
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.taskService.getTasksExport(this.taskFilters).subscribe(
      (res) => {
        console.log('Export data received:', res);
        const tasksList = res.data ? res.data : [];
        const rows = tasksList.map((t: ITask) => this.mapTaskToExportRow(t));

        if (rows.length === 0) {
          swal({
            title: 'Sin datos',
            text: 'No se encontraron tareas para los filtros seleccionados.',
            type: 'info',
          });
          return;
        }

        this.filexcelService.exportAsExcelFile(rows, this.buildExportFileName());
        swal({
          title: 'Exportación completada',
          text: `Se exportaron ${rows.length} tareas.`,
          type: 'success',
        });
      },
      (error) => {
        console.log(error);
        swal({
          title: 'Error al exportar',
          text: 'Ocurrió un error al intentar exportar las tareas. Intente nuevamente.',
          type: 'error',
        });
      }
    );
  }

  exportProspects() {
    swal({
      title: 'Generando Excel ...',
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.taskService.getTasksProspects().subscribe(
      (res: ITasksExportProspectsResponse) => {
        const prospectsList = res.data || [];
        const rows = prospectsList.map((p) => {
          const row: any = {};
          row.Nombre = (p.name && p.name.trim()) ? p.name : '';
          row.Telefono = (p.telephone && p.telephone.trim()) ? p.telephone : '';
          row['Nombre de contacto'] = (p.contact_name && p.contact_name.trim()) ? p.contact_name : '';
          row.Email = (p.email && p.email.trim()) ? p.email : '';
          row.Origen = (p.origin && p.origin.origin) ? p.origin.origin : '';
          return row;
        });

        if (rows.length === 0) {
          swal({
            title: 'Sin datos',
            text: 'No se encontraron prospectos para exportar.',
            type: 'info',
          });
          return;
        }

        this.filexcelService.exportAsExcelFile(rows, 'prospectos');
        swal({
          title: 'Exportación completada',
          text: `Se exportaron ${rows.length} prospectos.`,
          type: 'success',
        });
      },
      (error) => {
        console.log(error);
        swal({
          title: 'Error al exportar',
          text: 'Ocurrió un error al intentar exportar los prospectos. Intente nuevamente.',
          type: 'error',
        });
      }
    );
  }

  clearFilters() {
    this.taskFilters = {
      asesor_id: this.isCrmAdmin ? '' : this.userId,
      date_from: '',
      date_to: '',
      name: '',
      task_lines_id: '',
      task_types_id: '',
      origin_id: '',
      state: '',
      priority: '',
    };
    this.dateFromPicker = null;
    this.dateToPicker = null;
    this.isFiltering = false;
    this.pageNumber = 0;
    this.getTasks();
  }

  setPage(pageInfo: any) {
    this.pageNumber = pageInfo.offset;
    this.getTasks();
  }

  getPriorityLabel(priority: number): string {
    switch (priority) {
      case 0:
        return "Baja";
      case 1:
        return "Media";
      case 2:
        return "Alta";
      default:
        return "N/A";
    }
  }

  getPriorityClass(priority: number): string {
    switch (priority) {
      case 0:
        return "priority-low";
      case 1:
        return "priority-medium";
      case 2:
        return "priority-high";
      default:
        return "";
    }
  }

  getStateLabel(state: number): string {
    switch (state) {
      case 0:
        return "Pendiente";
      case 1:
        return "En progreso";
      case 2:
        return "Completada";
      default:
        return "N/A";
    }
  }

  getStateClass(state: number): string {
    switch (state) {
      case 0:
        return "state-pending";
      case 1:
        return "state-in-progress";
      case 2:
        return "state-completed";
      default:
        return "";
    }
  }

  getTaskLines() {
    this.taskService.getTaskLines().subscribe(
      (data) => {
        this.taksLines = data.data;
      },
      (error) => {
        console.log(error);
        swal({
          title: 'Error al obtener las líneas',
          text: 'Ocurrió un error al intentar obtener las líneas',
          type: 'error',
        });
      }
    );
  }
  
  getTaskTypes() {
    this.taskService.getTaskTypes().subscribe(
      (data) => {
        this.taskTypes = data.data;
      },
      (error) => {
        console.log(error);
        swal({
          title: 'Error al obtener los tipos',
          text: 'Ocurrió un error al intentar obtener los tipos',
          type: 'error',
        });
      }
    );
  }

  openLinesModal() {
    this.modalLinesList.show();
  }

  closeLinesModal() {
    this.modalLinesList.hide();
  }

  openTypesModal() {
    this.modalTypesList.show();
  }

  closeTypesModal() {
    this.modalTypesList.hide();
  }

  resetNewTask() {
    this.newTask = {
      task_lines_id: null,
      task_types_id: null,
      name: '',
      contact_name: '',
      email: '',
      telephone: '',
      origin_id: null,
      user_asigned_id: this.isCrmAdmin ? null : this.userId,
      description: '',
      priority: null,
    };
    this.newTaskMode = 'prospecto';
    this.selectedCustomerId = null;
    this.customerContacts = [];
    this.selectedContactId = null;
    this.loadingContacts = false;
    this.loadingCustomers = false;
    this.taskEditionMode = false;
    this.editingTaskId = null;
    this.selectedFiles = [];
  }

  setNewTaskMode(mode: 'prospecto' | 'cliente') {
    if (this.newTaskMode === mode) {
      return;
    }
    this.resetNewTask();
    this.newTaskMode = mode;
  }

  openCreateTaskModal() {
    this.resetNewTask();
    this.modalFormTask.show();
  }

  openEditTaskModal(task: ITask) {
    this.resetNewTask();
    this.taskEditionMode = true;
    this.editingTaskId = task.id;

    const isCliente = task.type === 1;
    this.newTaskMode = isCliente ? 'cliente' : 'prospecto';

    this.newTask.task_lines_id = task.task_lines_id;
    this.newTask.task_types_id = task.task_types_id;
    this.newTask.user_asigned_id = task.user_asigned_id;
    this.newTask.description = task.description || '';
    this.newTask.priority = task.priority;

    if (isCliente) {
      const customerId = task.customer ? task.customer.id : (task.origin_id || null);
      this.selectedCustomerId = customerId;
      this.selectedContactId = null;
      this.customerContacts = [];

      if (customerId) {
        this.loadCustomerContacts(customerId);
      }

      this.newTask.name = task.name || '';
      this.newTask.contact_name = task.contact_name || '';
      this.newTask.email = task.email || '';
      this.newTask.telephone = task.telephone || '';
      this.newTask.origin_id = task.origin_id || null;
    } else {
      this.newTask.name = task.name || '';
      this.newTask.contact_name = task.contact_name || '';
      this.newTask.email = task.email || '';
      this.newTask.telephone = task.telephone || '';
      this.newTask.origin_id = task.origin_id || null;
      this.selectedCustomerId = null;
      this.customerContacts = [];
      this.selectedContactId = null;
    }

    this.modalFormTask.show();
  }

  cancelCreateTask() {
    this.modalFormTask.hide();
    this.resetNewTask();
  }

  get attachmentsAcceptAttribute(): string {
    return this.ALLOWED_ATTACHMENT_EXTENSIONS.map(ext => `.${ext}`).join(',');
  }

  get hasSelectedFiles(): boolean {
    return this.selectedFiles.length > 0;
  }

  onFilesSelected(event: any) {
    const input = event.target as HTMLInputElement;
    if (!input || !input.files) {
      return;
    }

    const incoming: File[] = Array.prototype.slice.call(input.files);
    const rejected: string[] = [];

    incoming.forEach((file: File) => {
      const fileName = file.name || '';
      const dotIndex = fileName.lastIndexOf('.');
      const extension = dotIndex > -1 ? fileName.substring(dotIndex + 1).toLowerCase() : '';

      if (this.ALLOWED_ATTACHMENT_EXTENSIONS.indexOf(extension) === -1) {
        rejected.push(`"${fileName}" (tipo no permitido)`);
        return;
      }

      if (file.size > this.MAX_ATTACHMENT_SIZE_MB * 1024 * 1024) {
        rejected.push(`"${fileName}" (supera los ${this.MAX_ATTACHMENT_SIZE_MB} MB)`);
        return;
      }

      const isDuplicate = this.selectedFiles.some(
        (existing: File) =>
          existing.name === file.name && existing.size === file.size && existing.type === file.type
      );
      if (isDuplicate) {
        rejected.push(`"${fileName}" (ya seleccionado)`);
        return;
      }

      if (this.selectedFiles.length >= this.MAX_ATTACHMENTS) {
        rejected.push(`"${fileName}" (supera el máximo de ${this.MAX_ATTACHMENTS} archivos)`);
        return;
      }

      this.selectedFiles.push(file);
    });

    input.value = '';

    if (rejected.length > 0) {
      swal({
        title: 'Archivos no agregados',
        html: rejected.map(r => `<div>${r}</div>`).join(''),
        type: 'warning',
      });
    }
  }

  removeSelectedFile(index: number) {
    this.selectedFiles.splice(index, 1);
  }

  getFileSizeLabel(bytes: number): string {
    if (bytes < 1024) {
      return `${bytes} B`;
    }
    if (bytes < 1024 * 1024) {
      return `${(bytes / 1024).toFixed(0)} KB`;
    }
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }

  saveNewTask() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false,
    });
    swal.showLoading();

    const payload: any = {
      task_lines_id: this.newTask.task_lines_id,
      task_types_id: this.newTask.task_types_id,
      user_asigned_id: this.newTask.user_asigned_id,
      description: this.newTask.description,
      priority: this.newTask.priority,
    };

    if (this.newTaskMode === 'prospecto') {
      const required = ['task_lines_id', 'task_types_id', 'name', 'contact_name', 'email', 'origin_id', 'user_asigned_id', 'priority'];
      for (const field of required) {
        const value = this.newTask[field];
        if (value === null || value === undefined || value === '') {
          swal({
            title: 'Campos incompletos',
            text: `Por favor complete el campo ${field}.`,
            type: 'error',
          });
          return;
        }
      }

      if (this.newTask.name.length > 255 || this.newTask.contact_name.length > 255) {
        swal({
          title: 'Texto demasiado largo',
          text: 'Los campos de texto no pueden superar los 255 caracteres.',
          type: 'error',
        });
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.newTask.email)) {
        swal({
          title: 'Correo inválido',
          text: 'Por favor ingrese un correo electrónico válido.',
          type: 'error',
        });
        return;
      }

      if (this.newTask.telephone) {
        const phoneRegex = /^[0-9]{1,12}$/;
        if (!phoneRegex.test(this.newTask.telephone)) {
          swal({
            title: 'Teléfono inválido',
            text: 'El teléfono solo puede contener números y máximo 12 dígitos.',
            type: 'error',
          });
          return;
        }
      }

      payload.name = this.newTask.name;
      payload.contact_name = this.newTask.contact_name;
      payload.email = this.newTask.email;
      payload.telephone = this.newTask.telephone;
      payload.origin_id = this.newTask.origin_id;
      payload.type = 0;
    } else {
      if (!this.selectedCustomerId || !this.selectedContactId) {
        swal({
          title: 'Campos incompletos',
          text: 'Debe seleccionar un cliente y un contacto.',
          type: 'error',
        });
        return;
      }

      const customer = this.customersBasic.find(c => c.id === this.selectedCustomerId);
      const contact = this.customerContacts.find(c => c.id === this.selectedContactId);

      if (!customer || !contact) {
        swal({
          title: 'Datos inválidos',
          text: 'No se encontraron los datos del cliente o del contacto seleccionados.',
          type: 'error',
        });
        return;
      }

      if (!customer.origin_id) {
        swal({
          title: 'Cliente sin origen',
          text: 'El cliente seleccionado no tiene un origen asociado.',
          type: 'error',
        });
        return;
      }

      payload.name = customer.business_name || '';
      payload.contact_name = contact.name || '';
      payload.email = contact.email || '';
      payload.telephone = contact.telephone || '';
      payload.origin_id = customer.origin_id;
      payload.customer_id = customer.id;
      payload.type = 1;
    }

    const isEditing = this.taskEditionMode && this.editingTaskId !== null;

    let request$: Observable<ITaskResponse>;
    if (isEditing) {
      request$ = this.taskService.updateTask(this.editingTaskId, payload);
    } else if (this.selectedFiles.length > 0) {
      const formData = new FormData();
      Object.keys(payload).forEach((key: string) => {
        const value = payload[key];
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });
      this.selectedFiles.forEach((file: File) => {
        formData.append('attachments[]', file, file.name);
      });
      request$ = this.taskService.createTask(formData);
    } else {
      request$ = this.taskService.createTask(payload);
    }

    const successTitle = this.taskEditionMode ? 'Tarea modificada' : 'Tarea creada';
    const successText = this.taskEditionMode
      ? 'La tarea fue modificada correctamente.'
      : 'La tarea fue creada correctamente.';
    const errorTitle = this.taskEditionMode
      ? 'Error al modificar la tarea'
      : 'Error al crear la tarea';
    const errorText = this.taskEditionMode
      ? 'Ocurrió un error al intentar modificar la tarea.'
      : 'Ocurrió un error al intentar crear la tarea.';

    request$.subscribe(
      () => {
        this.getTasks();
        swal({
          title: successTitle,
          text: successText,
          type: 'success',
        });
        this.modalFormTask.hide();
        this.resetNewTask();
      },
      (error) => {
        console.log(error);
        swal({
          title: errorTitle,
          text: errorText,
          type: 'error',
        });
      }
    );
  }

  toggleLineForm(lineId: number = 0) {
    if (this.modalFormLine.visible) {
      this.modalFormLine.hide();
      this.newLine = '';
      this.lineIdToEdit = 0;
      return;
    }

    this.lineIdToEdit = lineId;
    if (lineId) {
      const line = this.taksLines.find(l => l.id === lineId);
      if (line) {
        this.newLine = line.name;
      }
    }
    this.modalFormLine.show();
  }
  
  toggleTypeForm(typeId: number = 0) {
    if (this.modalFormType.visible) {
      this.modalFormType.hide();
      this.newType = '';
      this.typeIdToEdit = 0;
      return;
    }

    this.typeIdToEdit = typeId;
    if (typeId) {
      const type = this.taskTypes.find(t => t.id === typeId);
      if (type) {
        this.newType = type.name;
      }
    }
    this.modalFormType.show();
  }

  createLine() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    if (!this.newLine) {
      swal({
        title: 'Por favor ingrese el nueva linea',
        text: 'Debe ingresar una descripcion valida para la linea',
        type: 'error'
      });
      return;
    }

    const newLineBody = { name: this.newLine };

    this.taskService.createTaskLine(newLineBody)
      .subscribe(
        data => {
          this.getTaskLines();
          swal({
            title: 'Linea agregada',
            type: 'success'
          });
          this.toggleLineForm();
        },
        error => {
          console.log(error);
          swal({
            title: 'Error al agregar la linea',
            text: 'Ocurrió un error al intentar agregar la nueva linea',
            type: 'error'
          });
        }
      );
  }

  updateLine() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    if (!this.newLine) {
      swal({
        title: 'Por favor ingrese la linea',
        text: 'Debe ingresar una descripcion valida para la linea',
        type: 'error'
      });
      return;
    }

    const lineBody = { name: this.newLine };

    this.taskService.updateTaskLine(this.lineIdToEdit, lineBody)
      .subscribe(
        data => {
          this.getTaskLines();
          swal({
            title: 'Linea modificada',
            type: 'success'
          });
          this.toggleLineForm();
        },
        error => {
          console.log(error);
          swal({
            title: 'Error al modificar la linea',
            text: 'Ocurrió un error al intentar modificar la linea',
            type: 'error'
          });
        }
      );
  }
  
  createType() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    if (!this.newType) {
      swal({
        title: 'Por favor ingrese el nuevo tipo',
        text: 'Debe ingresar una descripcion valida para el tipo',
        type: 'error'
      });
      return;
    }

    const newTypeBody = { name: this.newType };

    this.taskService.createTaskType(newTypeBody)
      .subscribe(
        data => {
          this.getTaskTypes();
          swal({
            title: 'Tipo agregado',
            type: 'success'
          });
          this.toggleTypeForm();
        },
        error => {
          console.log(error);
          swal({
            title: 'Error al agregar el tipo',
            text: 'Ocurrió un error al intentar agregar el nuevo tipo',
            type: 'error'
          });
        }
      );
  }

  updateType() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    if (!this.newType) {
      swal({
        title: 'Por favor ingrese el nuevo tipo',
        text: 'Debe ingresar una descripcion valida para el tipo',
        type: 'error'
      });
      return;
    }

    const typeBody = { name: this.newType };

    this.taskService.updateTaskType(this.typeIdToEdit, typeBody)
      .subscribe(
        data => {
          this.getTaskTypes();
          swal({
            title: 'Tipo modificado',
            type: 'success'
          });
          this.toggleTypeForm();
        },
        error => {
          console.log(error);
          swal({
            title: 'Error al modificar el tipo',
            text: 'Ocurrió un error al intentar modificar el tipo',
            type: 'error'
          });
        }
      );
  }

  getTaskAsesors() {
    this.taskService.getTaskAsesors()
      .subscribe(
        data => {
          this.asesors = data.data;
        },
        error => {
          console.log(error);
          swal({
            title: 'Error al obtener los asesores',
            text: 'Ocurrió un error al intentar obtener los asesores',
            type: 'error'
          });
        }
      );
  }

  getAllCustomerOrigins() {
    this.restService.getAllCustomerOrigins().then(data => {
      const resp: any = data;
      this.customerOrigins = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }

  openTaskDetail(task: ITask) {
    this.selectedTask = task;
    this.taskHistory = [];
    this.taskFiles = [];
    this.modalTaskDetail.show();
    this.taskService.getHistoryByTaskId(task.id).subscribe(
      (res) => {
        this.taskHistory = res.data;
      },
      (error) => {
        console.log(error);
        swal({
          title: 'Error al obtener el historial',
          text: 'No se pudo cargar el historial de la tarea.',
          type: 'error',
        });
      }
    );
  }

  openTaskFiles() {
    if (!this.selectedTask) {
      return;
    }
    this.taskFiles = [];
    this.loadingTaskFiles = true;
    this.modalTaskFiles.show();

    this.taskService.getTaskFiles(this.selectedTask.id).subscribe(
      (res) => {
        this.taskFiles = res.data || [];
        this.loadingTaskFiles = false;
      },
      (error) => {
        this.loadingTaskFiles = false;
        console.log(error);
        swal({
          title: 'Error al obtener los archivos',
          text: 'No se pudieron cargar los archivos de la tarea.',
          type: 'error',
        });
      }
    );
  }

  closeTaskFiles() {
    this.modalTaskFiles.hide();
  }

  getFileNameFromUrl(url: string): string {
    if (!url) {
      return '';
    }
    const cleanUrl = url.split('?')[0];
    const parts = cleanUrl.split('/');
    const lastPart = parts[parts.length - 1] || '';
    let decoded = lastPart;
    try {
      decoded = decodeURIComponent(lastPart);
    } catch (e) { }
    return decoded;
  }

  getFileExtensionFromUrl(url: string): string {
    const name = this.getFileNameFromUrl(url);
    const dotIndex = name.lastIndexOf('.');
    return dotIndex > -1 ? name.substring(dotIndex + 1).toLowerCase() : '';
  }

closeTaskDetail() {
    this.modalTaskDetail.hide();
    this.selectedTask = null;
    this.taskHistory = [];
    this.taskFiles = [];
    this.newHistoryEntry = {
      description: '',
      task_id: 0,
    };
    this.newFinishEntry = {
      description: '',
    };
    this.historyFormMode = 'history';
    this.finishAsCustomer = false;
    this.selectedCustomerId = null;
  }

  refreshTaskHistory(taskId: number) {
    this.taskService.getHistoryByTaskId(taskId).subscribe(
      (res) => {
        this.taskHistory = res.data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  deleteTask(task: ITask) {
    swal({
      title: '¿Eliminar tarea?',
      text: `¿Está seguro de eliminar la tarea "${task.name}"? Esta acción no se puede deshacer.`,
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      type: 'warning',
    }).then(res => {
      if (res.value) {
        swal({
          title: 'Eliminando ...',
          allowOutsideClick: false,
        });
        swal.showLoading();

        this.taskService.deleteTask(task.id).subscribe(
          () => {
            this.getTasks();
            swal({
              title: 'Tarea eliminada',
              type: 'success',
            });
          },
          (error) => {
            console.log(error);
            swal({
              title: 'Error al eliminar la tarea',
              text: 'No se pudo eliminar la tarea. Intente nuevamente.',
              type: 'error',
            });
          }
        );
      }
    });
  }

  openHistoryForm() {
    if (!this.selectedTask) {
      return;
    }
    this.historyFormMode = 'history';
    this.newHistoryEntry = {
      description: '',
      task_id: this.selectedTask.id,
    };
    this.newFinishEntry = {
      description: '',
    };
    this.modalFormHistory.show();
  }

  openFinishForm() {
    if (!this.selectedTask) {
      return;
    }
    this.historyFormMode = 'finish';
    this.newFinishEntry = {
      description: '',
    };
    this.newHistoryEntry = {
      description: '',
      task_id: this.selectedTask.id,
    };
    this.finishAsCustomer = false;
    this.selectedCustomerId = null;
    this.modalFormHistory.show();
  }

  loadCustomersBasicInfo() {
    if (this.customersBasic.length > 0) {
      return;
    }
    this.loadingCustomers = true;
    this.taskService.getCustomersBasicInfo().subscribe(
      (res) => {
        this.customersBasic = res.data;
        this.loadingCustomers = false;
      },
      (error) => {
        this.loadingCustomers = false;
        console.log(error);
      }
    );
  }

  onCustomerChange(customerId: number) {
    this.selectedCustomerId = customerId;
    this.selectedContactId = null;
    this.customerContacts = [];
    this.loadCustomerContacts(customerId);
  }

  loadCustomerContacts(customerId: number) {
    this.loadingContacts = true;
    this.restService.getCustomerContacts(customerId)
      .then((data: any) => {
        if (data && data.success && Array.isArray(data.data)) {
          this.customerContacts = data.data;
        } else {
          this.customerContacts = [];
        }
        this.loadingContacts = false;
      })
      .catch((error) => {
        this.loadingContacts = false;
        this.customerContacts = [];
        console.log(error);
      });
  }

  onContactChange(contactId: number) {
    this.selectedContactId = contactId;
  }

  toggleFinishAsCustomer(checked: boolean) {
    this.finishAsCustomer = checked;
    if (!checked) {
      this.selectedCustomerId = null;
    }
  }

cancelHistoryForm() {
    this.modalFormHistory.hide();
    this.newHistoryEntry = {
      description: '',
      task_id: this.selectedTask ? this.selectedTask.id : 0,
    };
    this.newFinishEntry = {
      description: '',
    };
    this.historyFormMode = 'history';
    this.finishAsCustomer = false;
    this.selectedCustomerId = null;
  }

  saveHistory() {
    if (!this.selectedTask) {
      return;
    }

    if (!this.newHistoryEntry.description || !this.newHistoryEntry.description.trim()) {
      swal({
        title: 'Campo incompleto',
        text: 'Por favor ingrese una descripción para el historial.',
        type: 'error',
      });
      return;
    }

    const payload: ITaskHistoryRequest = {
      description: this.newHistoryEntry.description.trim(),
      task_id: this.selectedTask.id,
    };

    swal({
      title: 'Guardando ...',
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.taskService.createTaskHistory(payload).subscribe(
      (res) => {
        swal({
          title: 'Historial actualizado',
          type: 'success',
        });
        this.modalFormHistory.hide();
        this.newHistoryEntry = {
          description: '',
          task_id: this.selectedTask ? this.selectedTask.id : 0,
        };
        this.historyFormMode = 'history';
        if (this.selectedTask) {
          const selectedTaskId = this.selectedTask.id;

          this.refreshTaskHistory(selectedTaskId);

          if (res.task) {
            this.selectedTask.state = res.task.state;

            const idx = this.tasks.findIndex(t => t.id === selectedTaskId);
            if (idx !== -1) {
              this.tasks[idx] = { ...this.tasks[idx], state: res.task.state };
            }

            console.log('Estado de la tarea actualizado:', this.tasks);
          }
        }
      },
      (error) => {
        console.log(error);
        swal({
          title: 'Error al guardar',
          text: 'No se pudo guardar el registro de historial. Intente nuevamente.',
          type: 'error',
        });
      }
    );
  }

  saveFinish() {
    if (!this.selectedTask) {
      return;
    }

    if (!this.newFinishEntry.description || !this.newFinishEntry.description.trim()) {
      swal({
        title: 'Campo incompleto',
        text: 'Por favor ingrese una descripción para terminar la tarea.',
        type: 'error',
      });
      return;
    }

    if (this.finishAsCustomer && (this.selectedCustomerId === null || this.selectedCustomerId === undefined)) {
      swal({
        title: 'Cliente requerido',
        text: 'Ha indicado que el prospecto fue registrado como cliente. Por favor seleccione un cliente.',
        type: 'error',
      });
      return;
    }

    const payload: ITaskFinishRequest = {
      description: this.newFinishEntry.description.trim(),
    };

    if (this.finishAsCustomer && this.selectedCustomerId !== null) {
      payload.customer_id = this.selectedCustomerId;
    }

    const selectedTaskId = this.selectedTask.id;

    swal({
      title: 'Terminando ...',
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.taskService.finishTask(selectedTaskId, payload).subscribe(
      () => {
        swal({
          title: 'Tarea terminada',
          type: 'success',
        });
        this.modalFormHistory.hide();
        this.newFinishEntry = {
          description: '',
        };
        this.historyFormMode = 'history';
        this.finishAsCustomer = false;
        this.selectedCustomerId = null;
        this.closeTaskDetail();
        this.getTasks();
      },
      (error) => {
        console.log(error);
        swal({
          title: 'Error al terminar la tarea',
          text: 'No se pudo terminar la tarea. Intente nuevamente.',
          type: 'error',
        });
      }
    );
  }

  getUser(id: number) {
      swal({
        title: "Obteniendo información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();
      this.userService
        .getUser(id)
        .then((data) => {
          const resp: any = data;
          console.log("User data received:", resp);
          if (resp.error) {
            swal({
              title: "Error",
              text: "Ha ocurrido un error",
              type: "error",
            });
          } else {
            this.crmAdmin = resp.data ? resp.data.crm_admin : null;
            this.applyCrmAdminRestrictions();
            swal.close();
          }
        })
        .catch((error) => {
          console.log(error);
          swal({
            title: "Error",
            text: "Ha ocurrido un error",
            type: "error",
          });
        })
        .then(() => {
          this.getTasks();
        });
  }

  applyCrmAdminRestrictions() {
    if (this.isCrmAdmin) {
      return;
    }
    this.taskFilters.asesor_id = this.userId;
    this.newTask.user_asigned_id = this.userId;
  }
}


// WEBPACK FOOTER //
// ./src/app/master/task-management/task-management.component.ts